import React, { useEffect, useState } from 'react';
import Creatable, { useCreatable } from 'react-select/creatable';
import { extractValues } from '../../Helper/helper';
import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { authAxios } from '../../config/config';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const AddTradingCategory = ({ handleCancel, handleAdd, allmodel, handleUpdate }) => {
    const { i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
    const [formData, setFormData] = useState({
        name: { en: '', ar: '' },
        image: ''
    });

    const handleInputChange = (field, lang, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: {
                ...prev[field],
                [lang]: value
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            name: {
                en: formData.name.en,
                ar: formData.name.ar
            },
            image: formData?.image
        }

        if (allmodel?.data?._id) {
            handleUpdate(payload)
        } else {
            handleAdd(payload)
        }


    };

    const fields = [
        { key: 'name', label: 'Name' },
    ];




    const handleProfileChange = async (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        await authAxios()
            .post("/admin/upload/single", formData)
            .then((response) => {
                const resData = response.data;
                console.log("handleProfileChange", resData)
                toast.success(resData.message);
                setFormData((prev) => ({
                    ...prev,
                    image: resData.data.url
                }))
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
    };



    useEffect(() => {
        if (allmodel && allmodel?.data?._id) {
            setFormData((prev) => ({
                ...prev,
                image: allmodel?.data?.image,
                name: {
                    en: allmodel.data.name.en,
                    ar: allmodel.data.name.ar,
                },
            }))
        }

    }, [])

    return (
        <div className="fixed inset-0 z-10">

            <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8 text-center">
                    <div className="relative transform overflow-hidden bg-white rounded-lg shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                        <div className="px-6 py-8">
                            <h2 className="text-lg font-medium text-gray-900 mb-6"> {allmodel?.data?._id ? <>Update Trading Category </> : <>Add  Trading Category</>} </h2>
                            <div className="flex items-center gap-4">
                                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2"></label>
                                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2">English </label>
                                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2">Arabic</label>
                            </div>
                            <form onSubmit={handleSubmit} className="space-y-6">
                                {fields.map(({ key, label }) => (
                                    <div key={key} className="flex items-center gap-4">
                                        <label className="w-1/4 text-sm font-medium text-gray-900 text-justify text-justify">{label}</label>

                                        <input
                                            type="text"
                                            placeholder={`${label} (EN)`}
                                            required
                                            value={formData[key]?.en || ''}
                                            onChange={(e) =>
                                                handleInputChange(key, 'en', e.target.value)
                                            }
                                            className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                        />
                                        <input
                                            type="text"
                                            placeholder={`${label} (AR)`}
                                            value={formData[key]?.ar || ''}
                                            onChange={(e) =>
                                                handleInputChange(key, 'ar', e.target.value)
                                            }
                                            required
                                            className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                        />
                                    </div>
                                ))}



                                <div className="grid grid-cols-12 gap-4">
                                    <div className="col-span-3">
                                        <label htmlFor="cover-photo" className="block text-sm font-medium text-gray-900 mb-2 text-justify">
                                           Image
                                        </label>

                                    </div>
                                    <div className="col-span-9">
                                        {
                                            formData.image == '' ? <div className="flex flex-col items-center rounded-lg border border-dashed border-gray-300 px-4 py-4">
                                                <PhotoIcon aria-hidden="true" className="text-gray-300 h-12 w-12 mb-2" />
                                                <div className="flex items-center text-sm text-gray-600">
                                                    <label
                                                        htmlFor="file-upload"
                                                        className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                                                    >
                                                        <span>Upload a file</span>
                                                        <input
                                                            id="file-upload"
                                                            name="file-upload"
                                                            type="file"
                                                            required
                                                            accept="image/jpeg,image/png,image/jpg"
                                                            onChange={handleProfileChange}
                                                            className="sr-only"
                                                        />
                                                    </label>
                                                    <p className="pl-2">or drag and drop</p>
                                                </div>
                                                <p className="mt-2 text-xs text-gray-500">PNG, JPG,JPEG up to 10MB</p>
                                            </div> :
                                                <>
                                                    <img
                                                        src={`${process.env.REACT_APP_IMAGE_URL}/${formData.image}`}
                                                        alt="Cover"
                                                        className="w-full h-40 object-cover rounded-lg mb-3"
                                                        loading="lazy"
                                                    />

                                                    <label
                                                        htmlFor="file-upload"
                                                        className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                                                    >
                                                        <span>Change Image</span>
                                                        <input
                                                            id="file-upload"
                                                            name="file-upload"
                                                            type="file"
                                                            accept="image/jpeg,image/png,image/jpg"
                                                            onChange={handleProfileChange}
                                                            className="sr-only"
                                                        />
                                                    </label>
                                                </>
                                        }

                                    </div>
                                </div>

                                <div className="flex gap-2 mt-4">
                                    <button
                                        type="button"
                                        onClick={handleCancel}
                                        className="w-1/2 rounded-md bg-gray-500 px-4 py-3 text-white hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 sm:text-sm"
                                    >
                                        Cancel
                                    </button>
                                    {
                                        allmodel?.data?._id ? <button
                                            type="submit"
                                            className="w-1/2 rounded-md bg-indigo-600 px-4 py-3 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                                        >
                                            Update
                                        </button> : <button
                                            type="submit"
                                            className="w-1/2 rounded-md bg-indigo-600 px-4 py-3 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                                        >
                                            Add
                                        </button>
                                    }

                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddTradingCategory;
